import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Connects to data-controller="auto-modal"
export default class extends Controller {
  connect() {
    new Modal(this.element).show()
  }
}
